import { render } from "./ViewJobVacancy.vue?vue&type=template&id=d57cc236&scoped=true"
import script from "./ViewJobVacancy.vue?vue&type=script&lang=js"
export * from "./ViewJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=d57cc236&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d57cc236"]])

export default __exports__